// Scheduling across the admin panel is always interpreted in US Eastern Time,
// regardless of the admin's browser timezone.
export const ET_ZONE = 'America/New_York';

// Offset (ms) of `zone` at a given UTC instant. Positive means ahead of UTC.
const getZoneOffsetMs = (zone, date) => {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: zone, hour12: false,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
    }).formatToParts(date).reduce((acc, p) => { acc[p.type] = p.value; return acc; }, {});
    const hour = parts.hour === '24' ? '00' : parts.hour;
    const asUTC = Date.UTC(parts.year, parts.month - 1, parts.day, hour, parts.minute, parts.second);
    return asUTC - date.getTime();
};

// "YYYY-MM-DDTHH:mm" wall-clock (in Eastern) -> epoch ms.
export const easternWallTimeToEpoch = (localStr) => {
    const [datePart, timePart] = localStr.split('T');
    const [y, mo, d] = datePart.split('-').map(Number);
    const [h, mi] = timePart.split(':').map(Number);
    const utcGuess = Date.UTC(y, mo - 1, d, h, mi);
    // Two passes so the offset is evaluated at the corrected instant — this
    // resolves the DST spring-forward hour where a single pass picks the
    // pre-transition offset.
    const off1 = getZoneOffsetMs(ET_ZONE, new Date(utcGuess));
    const off2 = getZoneOffsetMs(ET_ZONE, new Date(utcGuess - off1));
    return utcGuess - off2;
};

// epoch ms -> "YYYY-MM-DDTHH:mm" wall-clock in Eastern (for the input value).
export const epochToEasternWallTime = (epoch) => {
    const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: ET_ZONE, hour12: false,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit'
    }).formatToParts(new Date(epoch)).reduce((acc, p) => { acc[p.type] = p.value; return acc; }, {});
    const hour = parts.hour === '24' ? '00' : parts.hour;
    return `${parts.year}-${parts.month}-${parts.day}T${hour}:${parts.minute}`;
};

// epoch ms -> "YYYY-MM-DD" in Eastern (calendar day key).
export const epochToEasternDateKey = (epoch) => epochToEasternWallTime(epoch).split('T')[0];

// Human-readable current Eastern time, e.g. "Fri, Jul 4, 2026, 1:07:42 AM EDT".
export const formatEasternNow = () => new Intl.DateTimeFormat('en-US', {
    timeZone: ET_ZONE, hour12: true,
    weekday: 'short', year: 'numeric', month: 'short', day: 'numeric',
    hour: 'numeric', minute: '2-digit', second: '2-digit', timeZoneName: 'short'
}).format(new Date());

// epoch ms -> "Jul 4, 2026, 1:07 PM EDT".
export const formatEastern = (epoch) => new Intl.DateTimeFormat('en-US', {
    timeZone: ET_ZONE, hour12: true,
    year: 'numeric', month: 'short', day: 'numeric',
    hour: 'numeric', minute: '2-digit', timeZoneName: 'short'
}).format(new Date(epoch));
